import { nanoid } from "nanoid";
import * as z from "zod";

export const generateId = () => nanoid(12);

export const clientGeneratableIdSchema = z
  .string()
  .regex(/^[A-Za-z0-9_-]{12}$/);
